import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';

export const InfoStack = styled(Stack)`
  flex-direction: row;
  gap: 8px;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  word-wrap: break-word;
  word-break: break-word;
`;

export const TextStack = styled(Stack)`
  display: flex;
  flex-direction: row;
  gap: 4px;
  align-items: flex-start;
  width: 100%;
  font-size: 12px;
  font-weight: 500;
  text-align: left;
  flex-wrap: wrap;
`;

export const Title = styled('div')`
  color: ${({ theme }) => theme.palette.grey['01']};
  justify-content: flex-end;
`;

export const Value = styled('div')`
  color: ${({ theme }) => theme.palette.text.primary};
  flex-wrap: break-word;
  max-width: 200px;
`;
